import styled from '@emotion/styled';
import * as c from '@identity/constants';

export const Wrapper = styled.div`
  position: relative;
  background: ${c.colors.PRIMARY_007};
  padding-top: 80px;
  height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${c.TABLET} {
    height: 60vh;
  }

  img {
    filter: brightness(
      ${props => (props.imgBrightness ? props.imgBrightness : '75%')}
    );
  }
`;

export const Content = styled.div`
  position: relative;
  padding: 0 7vw;

  justify-content: center;
  align-items: center;

  h1 {
    font-size: 10vw;

    ${c.TABLET} {
      font-size: 8vw;
    }
  }

  p {
    text-align: center;
    font-size: 20px;

    color: white;
    z-index: 10;
    max-width: 600px;
    padding: 0 7vw;
  }
`;
